<template>
    <section id="home" class="pt-5 mb-5" :class="$root.getSectionClass('#home')">
        <div class="container">
            <div class="logo-container">
                <figure>
                    <a href="/">
                        <img alt="" width="200" src="../assets/logo.svg">
                    </a>
                </figure>
                <figure>
                    <img alt="" width="45%" src="../assets/ed.svg">
                </figure>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'HelloWorld',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    #home {
        background-image: url('../assets/home-bg.svg');
        background-size: cover;
        background-position: top;
        background-repeat: no-repeat;
        height: 100vh;
        max-height: 970px;
        .logo-container {
            padding-top: 150px;
            figure {
                position: relative;
            }
        }
        img.min {
            display: none;
        }
        @media (max-width: 575px) {
            & {
                height: 400px;
            }
        }
        @media (max-width: 991px) {
            & {
                background-image: url('../assets/home-bg-min.svg');
                background-size: 100%;
            }
            .logo-container {
                display: none;
            }
        }
        @media (max-height: 400px) {
            & {
                min-height: 800px;
            }
        }
    }
</style>
